(function () {

    'use strict';
    angular.module('app')
        .controller('oAuthPermissionsController',
            [
                '$scope', '$sce', '$location', '$routeParams', '$uibModal', '$cookies', 'stateService', 'accountsService', "dashboardService", "permissionsService",
                oAuthPermissionsController
            ]
        );

    function oAuthPermissionsController($scope, $sce, $location, $routeParams ,$uibModal,
        $cookies, stateService, accountsService, dashboardService, permissionsService) {

        $scope.modal = {
            clientId: $routeParams.clientId,
            redirectUrl: $routeParams.redirectUrl,
            scope: $routeParams.scope.split(" "),
            permissions: [],
            appicationName: "",
            stopAllow: true
        };

        $scope.checkAllow = function () {
            $scope.modal.stopAllow = $scope.modal.permissions.filter(function (item) {
                return item.checked;
            }).length === 0;
        };

        $scope.changeCheck = function (accountClient) {
            var client = $scope.modal.permissions.find(function (item) {
                return item.id === accountClient.id;
            });
            client.checked = !client.checked;
            $scope.checkAllow();
        };

        $scope.getAccountClinets = function (type) {
            return $scope.modal.permissions.filter(function (item) {
                return item.type === type;
            });
        };

        permissionsService.GetClientDetails($scope.modal.clientId).then(function (response) {
            console.log(response);
            $scope.modal.appicationName = response.oAuthClientName;
        });

        accountsService.getAuthorizedAccount().then(function (response) {
            $scope.modal.GatorClients = [];
            $scope.modal.account = {};
            $scope.modal.account = response;
            dashboardService.GetClients().then(function (data) {
                $scope.model.GatorClients = [];
                angular.forEach(data, function (client) {
                    if ($scope.modal.scope.includes(client.name.replace(".", "") + "Api")) {
                        $scope.modal.GatorClients.push(client);
                        angular.forEach($scope.modal.account.ssoClientUsers, function (accountClient) {
                            if (accountClient.ssoClientId === client.type) {
                                var item = {
                                    "id": accountClient.id,
                                    "displayName": accountClient.displayName,
                                    "checked": true,
                                    "type": client.type
                                };
                                if ($scope.modal.permissions.findIndex(function (clientItem) {
                                    return clientItem.id === item.id;
                                }) === -1) {
                                    $scope.modal.permissions.push(item);
                                }
                            }
                        });
                    }
                });
                $scope.checkAllow();
            });
        });

        $scope.allowAccess = function () {
            var checkedPermmissions = $scope.modal.permissions.filter(function (x) {
                return x.checked && x.type === 1;
            });
            var permissions = [];
            for (var i = 0; i < checkedPermmissions.length; i++) {
                var permission = checkedPermmissions[i];
                permissions.push({
                    "ssoClient": "GatorMailApi",
                    "value": permission.id
                });
            }

            if ($scope.modal.permissions.find(function (x) {
                return x.type === 3 && x.checked;
            }) != null) permissions.push({
                "ssoClient": "GatorLeadsApi",
                "value": "true"
            });

            if ($scope.modal.permissions.find(function (x) {
                return x.type === 9 && x.checked;
            }) != null) permissions.push({
                "ssoClient": "GatorSurveyApi",
                "value": "true"
            });

            permissionsService.PostTokenRefresh($scope.modal.clientId, $scope.modal.scope.join(","), permissions).then(function (data) {
                var location = $scope.modal.redirectUrl + ($scope.modal.redirectUrl.indexOf("?") > -1 ? "&" : "?") + "access_token=" + data.access_token + "&Expires=" + data.expires_in + "&refresh_token=" + data.refresh_token;
                window.location = location;
            });
        };

        $scope.denyAccess = function () {
            var url = $scope.modal.redirectUrl + ($scope.modal.redirectUrl.indexOf("?") > -1 ? "&" : "?") + "error=User Denied Access";
            window.location = url;
        };
    };
})();